import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor() { }

  handleError(error: any): void {
    console.error('🔥 TRAMPA DE ERROR GLOBAL:', error);
    // En un futuro, aquí se podría añadir un servicio de logging para enviar el error a un sistema externo.
  }
} 
